import React from 'react';

import Button, {ButtonTypes} from '../../components/ButtonNew';

const StepNavigation = ({onBack, nextLabel = 'Next', isSubmitting}) => (
  <div className="flex gap-3 pt-4">
    {onBack && (
      <Button type="button" buttonType={ButtonTypes.SECONDARY} className="flex-1" onClick={onBack}>
        Back
      </Button>
    )}
    <Button type="submit" className="flex-1" loading={isSubmitting} buttonType={ButtonTypes.SKEUOMORPHIC}>
      {nextLabel}
    </Button>
  </div>
);

export default StepNavigation;
